import React from 'react';
import {
    Box,
    Typography,
    Grid,
    Card,
    CardContent,
    CardActions,
    Button,
} from '@mui/material';
import { useNavigate } from 'react-router-dom';
import { CardGiftcard as CardGiftcardIcon, Dashboard as DashboardIcon, Groups as GroupsIcon } from '@mui/icons-material';
import { useAuth } from '../contexts/AuthContext';

const Dashboard = () => {
    const navigate = useNavigate();
    const { applicationModules } = useAuth();
    
    // Check if Giftcard Management (Application ID 1) is enabled
    const isGiftcardEnabled = applicationModules.some(
        app => app.ApplicationID === 1 && (app.SignedUp === true || app.SignedUp === 1)
    );

    // Check if Membership Platform (Application ID 2) is enabled
    const isMembershipEnabled = applicationModules.some(
        app => app.ApplicationID === 2 && (app.SignedUp === true || app.SignedUp === 1)
    );

    const dashboardTiles = [
        // Only show Giftcard Management if application ID 1 exists and is signed up
        ...(isGiftcardEnabled ? [{
            title: 'Giftcard Management',
            description: 'Manage giftcards, view transaction reports, and analyze giftcard sales trends',
            icon: <CardGiftcardIcon color="primary" />,
            buttonText: 'Open Giftcard Management',
            action: () => navigate('/giftcards'),
        }] : []),
        // Only show Membership Platform if application ID 2 exists and is signed up
        ...(isMembershipEnabled ? [{
            title: 'Membership Platform',
            description: 'Manage member profiles, view member lists, and track membership information',
            icon: <GroupsIcon color="primary" />,
            buttonText: 'Open Member List',
            action: () => navigate('/members'),
        }] : []),
        // Add more tiles here as the application grows
    ];

    return (
        <Box>
            <Typography variant="h4" component="h1" gutterBottom sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                <DashboardIcon color="primary" />
                Dashboard
            </Typography>
            <Typography variant="body1" color="text.secondary" paragraph>
                Welcome to Pulse Restaurant Operation Platform
            </Typography>
            
            <Grid container spacing={3}>
                {dashboardTiles.map((tile, index) => (
                    <Grid item xs={12} sm={6} md={4} key={index}>
                        <Card
                            sx={{
                                height: '100%',
                                display: 'flex',
                                flexDirection: 'column',
                                transition: 'transform 0.2s',
                                '&:hover': {
                                    transform: 'translateY(-2px)',
                                    boxShadow: 3,
                                },
                            }}
                        >
                            <CardContent sx={{ flexGrow: 1 }}>
                                <Box
                                    sx={{
                                        display: 'flex',
                                        alignItems: 'center',
                                        mb: 2,
                                    }}
                                >
                                    {tile.icon}
                                    <Typography
                                        variant="h5"
                                        component="h2"
                                        sx={{ ml: 1 }}
                                    >
                                        {tile.title}
                                    </Typography>
                                </Box>
                                <Typography variant="body2" color="text.secondary">
                                    {tile.description}
                                </Typography>
                            </CardContent>
                            <CardActions>
                                <Button
                                    size="small"
                                    variant="contained"
                                    onClick={tile.action}
                                    fullWidth
                                >
                                    {tile.buttonText}
                                </Button>
                            </CardActions>
                        </Card>
                    </Grid>
                ))}
            </Grid>
        </Box>
    );
};

export default Dashboard;
